import React from 'react';
import { useNavigate } from 'react-router-dom';

import checkImage from '../../images/icons/checkSucces.svg';

const ClientFormSuccess = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {/* Title inline with check icon — matches reference .titleSuccess */}
      <p
        style={{
          fontWeight: 'bold',
          fontSize: 'calc(14px + 0.4vw)',
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        <img src={checkImage} alt="Sucesso" />
        PEDIDO ENVIADO COM SUCESSO!
      </p>

      <p>Em breve um vendedor entrará em contato para prosseguir com o seu pedido.</p>
      <p>Em caso de dúvidas, entre em contato com seu consultor.</p>

      {/* Divider */}
      <div
        style={{
          marginTop: '10px',
          borderBottom: '1px solid #d0d0d0',
          width: '100%',
        }}
      />

      {/* Button — olive/yellow-green, filled, matches reference .Button */}
      <button
        type="button"
        onClick={() => navigate('/orders')}
        style={{
          color: '#ffffff',
          margin: '30px 5px',
          width: '180px',
          textTransform: 'none',
          border: 'none',
          fontWeight: 'lighter',
          padding: '8px',
          borderRadius: '5px',
          backgroundColor: '#859905',
          cursor: 'pointer',
          fontSize: '14px',
        }}
      >
        Ir para Minhas Vistorias
      </button>
    </div>
  );
};

export default ClientFormSuccess;
